<template>
  <Block
    label="หนังสือประกอบการเรียน"
    class="this-block"
    id="course-outline-books"
    fit
  >
    <div slot="header" class="-header">
      <div class="--title">
        <span>หนังสือประกอบการเรียน</span>
      </div>
    </div>

    <div class="-body">
        <div class="book-info">
          <div class="-header">
            <span class="--title">
              เล่มที่ 1
            </span>
            <div class="--controllers">
              <vx-tooltip text="Edit">
                <vs-button
                  class="controller-buttons"
                  radius
                  color="gray"
                  type="gradient"
                  icon="edit"
                  @click="$emit('call-editor', 'edit-textbooks',
                    { mode: 'edit', data: { ...requiresData, bookNo: 1 } }
                  )"
                />
              </vx-tooltip>
            </div>
          </div>
          <div class="-content">
            <div class="--title">
              {{ data.bookName1 }}
            </div>
            <div v-if="data.bookPic1" class="--image">
              <img :src="data.bookPic1">
            </div>
            <div class="--description">
              {{ data.bookDescription1 }}
            </div>
          </div>
        </div>
        <div class="book-info">
          <div class="-header">
            <span class="--title">
              เล่มที่ 2
            </span>
            <div class="--controllers">
              <vx-tooltip text="Edit">
                <vs-button
                  class="controller-buttons"
                  radius
                  color="gray"
                  type="gradient"
                  icon="edit"
                  @click="$emit('call-editor', 'edit-textbooks',
                    { mode: 'edit', data: { ...requiresData, bookNo: 2 } }
                  )"
                />
              </vx-tooltip>
            </div>
          </div>
          <div class="-content">
            <div class="--title">
              {{ data.bookName2 }}
            </div>
            <div v-if="data.bookPic2" class="--image">
              <img :src="data.bookPic2">
            </div>
            <div class="--description">
              {{ data.bookDescription2 }}
            </div>
          </div>
        </div>
        <div class="book-info">
          <div class="-header"> 
            <span class="--title">
              เล่มที่ 3
            </span>
            <div class="--controllers">
              <vx-tooltip text="Edit">
                <vs-button
                  class="controller-buttons"
                  radius
                  color="gray"
                  type="gradient"
                  icon="edit"
                  @click="$emit('call-editor', 'edit-textbooks',
                    { mode: 'edit', data: { ...requiresData, bookNo: 3 } }
                  )"
                />
              </vx-tooltip>
            </div>
          </div>
          <div class="-content">
            <div class="--title">
              {{ data.bookName3 }}
            </div>
            <div v-if="data.bookPic3" class="--image">
              <img :src="data.bookPic3">
            </div>
            <div class="--description">
              {{ data.bookDescription3 }}
            </div>
          </div>
        </div>
      </div>
  </Block>
</template>

<script>
import { Block } from "@/components/common-ui";
import { deleteCourseOutlineUnitById } from "@/services/api/course-outline";
import InternalEventBus from "../eventbus";

export default {
  components: {
    Block
  },
  props: {
    books: Object,
    data: Object,
    courseOutlineId: String,
    methods: Object
  },
  data() {
    return {
      textarea: ""
    }
  },
  computed: {
    requiresData() {
      let data = { ...this.data };
      data.courseOutlineId = this.data.id;
      delete data.degree;
      delete data.subjectGroup;
      delete data.subject;
      delete data.subjectCode;
      delete data.teacher;
      delete data.teacherCode;
      delete data.courseOutlineUnits;
      delete data.courseOutlineAssessments;
      return data;
    }
  },
  methods: {
    reloadData() {
      if (this.methods) {
        if (Object.prototype.hasOwnProperty.call(this.methods, 'reloadData')) {
          this.methods.reloadData();
        }
      }
    },
    async deleteUnit(id) {
      const sure = confirm("ต้องการลบหน่วยการเรียนนี้ใช่หรือไม่?");
      if (sure) {
        await deleteCourseOutlineUnitById(id);
        this.methods.reloadData();
      }
    }
  },
  mounted() {
    InternalEventBus.$on('FORECE_UPDATE', () => {
      this.reloadData()
    });
  }
}
</script>

<style lang="scss" scoped deep>
@import 'common-scoped';

.this-block{
  &#course-outline-books {
    width: 100%;
    height: 300px;

    & .-body {
      display: inline-flex;
      justify-content: space-around;
      flex-direction: row;
    
      & > div {
        flex-grow: 1;
        flex-basis: 0;
        height: 240px;

        margin: 8px;
        padding: 0;
        border: 1px solid #ddd;
        // background: #f3e5c4;
        background: #eeeeee;
        box-shadow: 0 1px 10px 0 rgba(0,0,0,.1);

        border-radius: 6px;
    
        &:not(:first-child) {
          margin-left: 20px;
        }
      }
    
      & .book-info {
        & .-header {
          background: #e2e2e2;
          color: black;
          border-radius: 6px 6px 0 0;
          border-bottom: 1px solid #bbbbbb80;
          padding-bottom: 4px;
          padding: 8px;
    
          & .--title {
            font-size: 1rem;
            letter-spacing: 0.3px;
          }
    
          & .--controllers {
            & button.controller-buttons {
              width: 20px !important;
              height: 20px !important;
              margin: 2px;
              font-size: 12px;
              background: grey;
      
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: -4px;
            
              & /deep/ i {
                line-height: 0 !important;
              }
            
            }
          }
        }

        & .-content {
          padding: 8px;

          & .--title {
            font-size: 1rem;
            font-weight: 450;
            letter-spacing: 0.3px;
          }

          & .--description {
            padding: 2px;
          }
        }
      } 
    } 
  }
}
</style>
